import React from 'react';
import ReactPaginate from "react-paginate";

const Pagination = ({total_pages, currentPage, onPageChange}) => {
  return (
    <ReactPaginate
      containerClassName="pagination"
      pageClassName="page-item"
      pageLinkClassName="page-link"
      activeClassName="active"
      pageCount={total_pages}
      forcePage={currentPage - 1}
      onPageChange={onPageChange}
    />);
}

export default Pagination;